import { useTranslation } from 'react-i18next';

import InvoicesReport from './InvoicesReport';
import RevenueReport from './RevenueReport';
import SettlementsReport from './SettlementsReport';
import UI from '../../common/UI';
import useDocumentTitle from '../../common/useDocumentTitle';
import useProject from '../useProject';

type ReportType = 'revenue' | 'settlements' | 'invoices';

export interface ReportsPageProps {
  type?: ReportType;
}

const ReportsPage = ({ type }: ReportsPageProps) => {
  const { t } = useTranslation();
  const project = useProject();

  useDocumentTitle(t('reports'));

  const basePath = `/${project.id}/reports`;

  return (
    <UI.Section sc={{ compact: true }}>
      <UI.GridContainer>
        <UI.SectionHeading>
          {t('reports')}
        </UI.SectionHeading>

        <UI.GridContainer sc={{ gutter: 0.5 }}>
          <UI.CollapsibleNavCard
            to={`${basePath}${type === 'revenue' ? '' : '/revenue'}`}
            preview={(
              <UI.Div>
                <UI.H4>{t('revenue')}</UI.H4>
                {t('revenue_report_description')}
              </UI.Div>
            )}
            body={(
              <RevenueReport />
            )}
            open={type === 'revenue'}
            muted={type && type !== 'revenue'}
            ariaLabel={t('revenue')}
          />

          <UI.CollapsibleNavCard
            to={`${basePath}${type === 'settlements' ? '' : '/settlements'}`}
            preview={(
              <UI.Div>
                <UI.H4>{t('settlements')}</UI.H4>
                {t('settlements_report_description')}
              </UI.Div>
            )}
            body={(
              <SettlementsReport />
            )}
            open={type === 'settlements'}
            muted={type && type !== 'settlements'}
            ariaLabel={t('settlements')}
          />

          <UI.CollapsibleNavCard
            to={`${basePath}${type === 'invoices' ? '' : '/invoices'}`}
            preview={(
              <UI.Div>
                <UI.H4>{t('invoices')}</UI.H4>
                {t('invoices_report_description')}
              </UI.Div>
            )}
            body={(
              <InvoicesReport />
            )}
            open={type === 'invoices'}
            muted={type && type !== 'invoices'}
            ariaLabel={t('invoices')}
          />
        </UI.GridContainer>
      </UI.GridContainer>
    </UI.Section>
  );
};

export default ReportsPage;
